import * as React from "react";

function SvgTomorrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path d="M13 24l10-8-10-8v16zM8 8h3v16H8z" fill="#fff" />
    </svg>
  );
}

export default SvgTomorrow;
